export default "__VITE_ASSET__07gvO1IvTzTCTyYqp_a5mw__ 220w";